import React from "react";
import { th } from "../../Shared/Styles";

export default function ConditionsTableRowHead(props) {
  if (props !== undefined) {
    return (
          <thead>
            <tr>
              <th style={{border: '1px solid black', textAlign: 'left', fontSize: '15px', width: '12%', marginBottom: '13px', color: 'black', paddingLeft: '20px'}}>Benefit Type</th>
              <th style={{border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '20px'}}>Percentage Loading</th>
              <th style={th}>Per Mille Loading</th>
              <th style={th}>Has Exclusion(s)</th>
            </tr>
          </thead>
    );
  }
}
